<template>
	<div class="authority-login-info">
		<v-search-login-info
			:loginInfo="loginInfo"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:multipleSelection="multipleSelection"
			v-on:update="update"
		></v-search-login-info>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="logList"
				style="width: 100%"
				max-height="638"
				:border="true"
				@selection-change="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					width="40"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="userName"
					:label="$t('loginInfo.userName')"
					width="200"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="ip"
					:label="$t('loginInfo.ipAddress')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="locale"
					:label="$t('loginInfo.loginLocation')"
					width="120"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="client"
					:label="$t('loginInfo.browser')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="os"
					:label="$t('loginInfo.os')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					:label="$t('loginInfo.state')"
					width="150"
					:align="'center'"
				>
					<template slot-scope="scope">
						<span :class="scope.row.state === 0 ? 'vtm-pill vtm-pill--ok' : 'vtm-pill vtm-pill--crit'">{{
							scope.row.state === 0 ? $t("common.success") : $t("common.error")
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="info"
					:show-overflow-tooltip="true"
					:label="$t('loginInfo.info')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('loginInfo.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import vSearchLoginInfo from "@/components/authority/log/SearchLoginInfo";
export default {
	name: "LoginInfo",
	components: {
		vSearchLoginInfo,
	},
	data() {
		return {
			logList: [],
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			loginInfo: {
				locale: "",
				userName: "",
				state: "",
				startTime: "",
				endTime: "",
			},
			multipleSelection: [],
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = !this.loading;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			this.$api
				.request(
					this.$url.LoginInfo.page,
					this.$method.get,
					this.$cloud.objMerge(this.loginInfo, this.page)
				)
				.then(
					res => {
						if (res.code === 0) {
							if (res.data && res.data.records) {
								this.logList = res.data.records;
								this.page.totalSize = parseInt(res.data.total);
							}
						}
						this.loading = !this.loading;
					},
					() => {
						this.loading = !this.loading;
					}
				);
		},

		handleSelectionChange(row) {
			this.multipleSelection = row;
		},

		onSubmit() {
			this.currentChange();
		},

		resetSearch() {
			this.currentChange();
		},

		update() {
			this.currentChange();
		},
	},
};
</script>

<style scoped></style>
